import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function VideoCameraFrontIcon(props: IconProps) {
    return <Icon {...props} iconKey={"video_camera_front"}/>
}
